import { ConfigurationInfoText, } from "../Configuration/ConfigurationInfoText";
/**
 * Displays info text on attribute level
 * @param props
 * @returns
 */
export const AttributeInfoText = ConfigurationInfoText;
//# sourceMappingURL=AttributeInfoText.js.map